import React, { Component } from "react";
import getConfig from "next/config";
import Link from "next/link";

import Heading from "@components/Heading";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

class RelatedArticles extends Component {
  render() {
    const { items } = this.props;

    if (!items || !items.length) {
      return null;
    }

    return (
      <div className="bg-gray-lighter rounded px-5 pt-4 pb-5 rounded-tr-lg rounded-bl-lg">
        <Heading
          title="Te-ar mai putea interesa"
          as="h2"
          display="h2"
          classesProp="-tracking-0.5 text-2xl leading-31.2"
        />

        <ul className="m-0 mt-3 p-0">
          {items &&
            items.map((item) => (
              <li key={item.slug} className="mt-1">
                <Link
                  href={`${settings.baseUrl}/suport-clienti/${item.slug}/`}
                  passHref
                >
                  <a className="inline-block text-sm leading-24 text-red-brand -tracking-0.29">
                    {`${item.name}`}
                  </a>
                </Link>
              </li>
            ))}
        </ul>
      </div>
    );
  }
}

export default RelatedArticles;
